<template>
  <div>
    <div class="row">
      <div class="col-9">
        <h1 class="font-weight-bold text-uppercase">Cupons para assinatura do App/Site</h1>
      </div>
      <div class="col-3 butonCupom">
        <button class="btn btn-info mr-2" @click="$router.push({ name: 'administrador-assinatura-planos-app' })">Atualizar plano(s)</button>
        <button class="btn btn-primary" @click="modalCupom()">+</button>
      </div>
    </div>

    <hr class="linha-amarela" />

    <table class="table">
      <thead class="thead-dark">
        <tr>
          <th class="text-center">Cupom</th>
          <th class="text-left">Plano</th>
          <th class="text-center">Prazo</th>
          <th class="text-center">Valor Plano</th>
          <th class="text-center">Status</th>
          <th class="text-center">Comissão</th>
          <th class="text-center">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, i) in cupons" :key="i">
          <td class="text-center">{{item.cupom}}</td>
          <td class="text-left">{{item.nome}}</td>
          <td class="text-center">{{item.tempo_contrato}} {{item.tempo_contrato_texto}}</td>
          <td class="text-center">{{item.preco_formatado}}</td>
          <td class="text-center">{{ item.status == true ? 'Ativo' : 'Inativo'}}</td>
          <td class="text-center">{{ item.comissao == true ? 'Desativada' : 'Ativada'}}</td>
          <td class="text-center">
            <i class="fas fa-copy cursor-pointer mr-2" title="Copiar link" @click="copiarLink(item.id)"></i>
            <i 
              class="fas fa-file-download cursor-pointer mr-2"
              title="Ver contrato"
              @click="showContratoPlano(item.comissao == true ? 'contrato-sem-comissao' : 'contrato-lojista-plano-pagamento', item)"
            ></i>
            <i class="fas fa-edit cursor-pointer mr-2" title="Editar" @click="modalCupom(item)"></i>
            <i class="fas fa-ban cursor-pointer mr-2" title="Inativar" @click="inativar(item.id)"></i>
            <i class="fas fa-trash cursor-pointer" title="Excluir" @click="excluir(item.id)"></i>
          </td>
        </tr>
      </tbody>
    </table>

    <b-modal id="cupom-plano" size="lg" title="Cupom para plano" hide-footer>
      <div class="row mb-4">
        
        <div class="col-md-12">
          <label>Cupom</label>
          <input type="text" class="form-control" v-model="fields.cupom">
        </div>

        <div class="col-md-12 mt-3">
          <label>Plano</label>
          <select v-model="fields.plano_assinatura_id" class="form-control">
            <option v-for="plano in planos" v-bind:value="plano.id" v-bind:key="plano.id">
              {{ plano.nome }} - {{ plano.preco_formatado }}
            </option>
          </select>
        </div>

        <div class="col-md-6 mt-3">
          <label>Tempo contrato (Mês)</label>
          <input 
            type="text" 
            class="form-control" 
            v-model="fields.tempo_contrato"
            v-mask="['##']"
          >
        </div>

        <div class="col-md-6 mt-3">
          <label>Tempo contrato por escrito</label>
          <input type="text" class="form-control" v-model="fields.tempo_contrato_texto">
        </div>
        
        <div class="col-md-6 mt-3">
          <b-form-checkbox 
            switch 
            v-model="fields.marketing_incluso"
            @change="hasMarketing()"
          >
            Marketing incluso?
          </b-form-checkbox>
        </div>
        
        <div class="col-md-6 mt-3">
          <b-form-checkbox switch v-model="fields.comissao">
            Desativar comissão?
          </b-form-checkbox>
        </div>

        <div v-if="fields.marketing_incluso" class="col-md-12 mt-4">
          <b-form-checkbox switch v-model="garantia" @change="validWarranty()">
            Tem garantia?
          </b-form-checkbox>
        </div>

        <div class="row px-3" v-if="garantia">
          <div class="col-md-6 mt-3">
            <label>Mês garantia</label>
            <input type="text" class="form-control" v-model="fields.mes_garantia" v-mask="['##']">
          </div>
          
          <div class="col-md-6 mt-3">
            <label>Mês garantia por escrito</label>
            <input type="text" class="form-control" v-model="fields.mes_garantia_texto">
          </div>
          
          <div class="col-md-6 mt-3">
            <label>Valor garantia</label>
            <InputMoney
              class="form-control" 
              v-model="fields.valor_garantia"
            />
          </div>
          
          <div class="col-md-6 mt-3">
            <label>Valor garantia por escrito</label>
            <input type="text" class="form-control" v-model="fields.valor_garantia_texto">
          </div>
        </div>

        <div class="col-md-12 mt-4">
          <h5 >Meios de pagamento</h5>
          <div class="d-flex mt-3">
            <div>
              <b-form-checkbox switch v-model="pagamento.cartao">
                Cartão
              </b-form-checkbox>
            </div>
            <div class="mx-3">
              <b-form-checkbox switch v-model="pagamento.pix">
                Pix
              </b-form-checkbox>
            </div>
            <div>
              <b-form-checkbox switch v-model="pagamento.boleto">
                Boleto
              </b-form-checkbox>
            </div>
          </div>
        </div>

        <div class="col-md-6 mt-4">
          <label>Data do primeiro pagamento</label>
          <b-calendar 
            v-model="fields.data_pagamento" 
            locale="pt-BR"
          ></b-calendar>
        </div>

        <div class="col-md-6 mt-4">
          <label>Data pagamento por escrito</label>
          <input type="text" class="form-control" v-model="fields.data_pagamento_texto">
        </div>

        <div class="col-md-12 text-center mt-5">
          <button class="btn btn-success btn-block" @click="sendCupom()">{{fields.id == null ? 'Salvar' : 'Atualizar'}}</button>
        </div>
      </div>
    </b-modal>

    <PaymentPlanContract
      v-if="contrato == 'contrato-lojista-plano-pagamento'"
      :contratoDados="contratoDados"
    />

    <PaymentPlanSemComissao
      v-if="contrato == 'contrato-sem-comissao'"
      :contratoDados="contratoDados"
    />
</div>
</template>

<script>
import makeToast from '@/mixins/makeToast';
import PaymentPlanContract from "../../components/PaymentPlanContract.vue";
import PaymentPlanSemComissao from "../../components/PaymentPlanSemComissao.vue";
import TypePayment from "@/enums/TypePayment";
import InputMoney from '@/components/Inputs/InputMoney.vue'
import { convertBrlToDecimal } from '@/utils';

export default {

  name: 'LojistasCupons',
  mixins: [makeToast],

  components: {
    PaymentPlanContract,
    PaymentPlanSemComissao,
    InputMoney
  },

  data() {
    return {
      TypePayment,
      planos: [],
      cupons: [],
      contrato: '',
      contratoDados: [],
      pagamento: {
        pix: false,
        boleto: false,
        cartao: false,
      },
      garantia: false,
      fields: {
        id: null,
        cupom: '',
        tempo_contrato: null,
        comissao: false,
        tempo_contrato_texto: '',
        plano_assinatura_id: null,
        forma_pagamento: null,
        mes_garantia: '',
        mes_garantia_texto: '',
        valor_garantia: '',
        valor_garantia_texto: '',
        marketing_incluso: false,
        data_pagamento: '',
        data_pagamento_texto: ''
      }
    }
  },

  created() {
    this.get();
  },

  methods: {
    showContratoPlano(contrato, contratoDados) {
      this.contrato = contrato;
      this.contratoDados = contratoDados;
      this.$bvModal.show(contrato);
    },
    modalCupom(item='') {
      if(item != '') {
        this.fields.id = item.id;
        this.fields.cupom = item.cupom;
        this.fields.tempo_contrato = item.tempo_contrato;
        this.fields.tempo_contrato_texto = item.tempo_contrato_texto;
        this.fields.comissao = item.comissao == 1 ? true : false;
        this.fields.plano_assinatura_id = item.plano_assinatura_id;
        this.fields.forma_pagamento = item.forma_pagamento;;
        this.fields.mes_garantia = item.mes_garantia;
        this.fields.mes_garantia_texto = item.mes_garantia_texto;
        this.fields.valor_garantia = item.valor_garantia;
        this.fields.valor_garantia_texto = item.valor_garantia_texto;
        this.fields.marketing_incluso = item.marketing_incluso;
        this.fields.data_pagamento = item.data_pagamento;
        this.fields.data_pagamento_texto = item.data_pagamento_texto;
        this.garantia = item.mes_garantia ? true : false;
        this.getPaymentType(item.forma_pagamento);
      } else {
        this.fields.id = null;
        this.fields.cupom = '';
        this.fields.tempo_contrato = null;
        this.fields.comissao = false;
        this.fields.tempo_contrato_texto = '';
        this.fields.plano_assinatura_id = null;
        this.fields.forma_pagamento = null;
        this.fields.mes_garantia = '';
        this.fields.mes_garantia_texto = '';
        this.fields.valor_garantia = '';
        this.fields.valor_garantia_texto = '';
        this.fields.marketing_incluso = false;
        this.garantia = false;
        this.pagamento.pix = false;
        this.pagamento.boleto = false;
        this.pagamento.cartao = false;
        this.fields.data_pagamento = '';
        this.fields.data_pagamento_texto = '';
      }
      this.$bvModal.show('cupom-plano');
    },
    copiarLink(id) {
      const url = process.env.VUE_APP_CURRENT_SITE_ADDRESS+'/cadastro-assinatura/'+btoa(id);
      navigator.clipboard.writeText(url);
      this.makeToast('Sucesso!', 'Link copiado com sucesso!', 'success');
    },
    sendCupom() {
      const garantia = convertBrlToDecimal(this.fields.valor_garantia).toFixed(2);
      this.fields.valor_garantia = garantia;

      this.selectPayment();
      if(this.validateFields() !== true) return

      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/assinaturaCuponsSend', this.fields)
      .then(() => {
        this.$bvModal.hide('cupom-plano');
        this.makeToast('Sucesso!', 'Salvo/atualizado com sucesso!', 'success');
        this.get();
      })
      .catch(() => {
        this.makeToast('Oops!', 'Não foi possível salvar/atualizar, tente novamente!', 'danger');
      })
      .finally(() => {
        this.$store.dispatch('endLoader');
      });
    },
    inativar(id) {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/assinaturaCuponsInativar', id)
      .then(() => {
        this.makeToast('Sucesso!', 'Atualizado com sucesso!', 'success');
        this.get();
      })
      .catch(() => {
        this.makeToast('Oops!', 'Erro ao atualizar, tente novamente!', 'danger');
      })
      .finally(() => {
        this.$store.dispatch('endLoader');
      });
    },
    excluir(id) {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/assinaturaCuponsExcluir', id)
      .then(() => {
        this.makeToast('Sucesso!', 'Excluido com sucesso!', 'success');
        this.get();
      })
      .catch(() => {
        this.makeToast('Oops!', 'Erro ao excluir, tente novamente!', 'danger');
      })
      .finally(() => {
        this.$store.dispatch('endLoader');
      });
    },
    get() {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/assinaturaCupons')
      .then((response) => {
        if(response.data.cupons) {
          this.cupons = response.data.cupons;
        }

        if(response.data.planos) {
          this.planos = response.data.planos;
        }
      })
      .catch(() => {
        this.makeToast('Oops!', 'Não foi possível buscar os cupons, tente novamente!', 'danger');
      })
      .finally(() => {
        this.$store.dispatch('endLoader');
      });
    },
    getPaymentType(type) {
      switch (type) {
        case this.TypePayment.TODOS:
          this.pagamento.pix = true;
          this.pagamento.cartao = true;
          this.pagamento.boleto = true;
          break;
        case this.TypePayment.PIX_CARTAO:
          this.pagamento.pix = true;
          this.pagamento.cartao = true;
          break;
        case this.TypePayment.PIX_BOLETO:
          this.pagamento.pix = true;
          this.pagamento.boleto = true;
          break;
        case this.TypePayment.BOLETO_CARTAO:
          this.pagamento.boleto = true;
          this.pagamento.cartao = true;
          break;
        case this.TypePayment.PIX:
          this.pagamento.pix = true;
          break;
        case this.TypePayment.CARTAO:
          this.pagamento.cartao = true;
          break;
        case this.TypePayment.BOLETO:
          this.pagamento.boleto = true;
          break;
        default:
          this.pagamento.pix = false;
          this.pagamento.cartao = false;
          this.pagamento.boleto = false;
          break;
      }
    },
    selectPayment() {
      if(this.pagamento.pix && this.pagamento.cartao && this.pagamento.boleto) {
        this.fields.forma_pagamento = this.TypePayment.TODOS;
      }else if(this.pagamento.boleto && this.pagamento.cartao) {
        this.fields.forma_pagamento = this.TypePayment.BOLETO_CARTAO;
      }else if(this.pagamento.pix && this.pagamento.cartao) {
        this.fields.forma_pagamento = this.TypePayment.PIX_CARTAO;
      } else if(this.pagamento.pix && this.pagamento.boleto) {
        this.fields.forma_pagamento = this.TypePayment.PIX_BOLETO;
      }else if(this.pagamento.cartao) {
        this.fields.forma_pagamento = this.TypePayment.CARTAO;
      }else if(this.pagamento.boleto) {
        this.fields.forma_pagamento = this.TypePayment.BOLETO;
      }else if(this.pagamento.pix) {
        this.fields.forma_pagamento = this.TypePayment.PIX;
      }else {
        this.fields.forma_pagamento = null;
      }
    },
    validateFields(){
      if(!this.fields.cupom) return this.makeToast('Oops!', 'Campo cupom vazio!', 'danger');
      if(!this.fields.plano_assinatura_id) return this.makeToast('Oops!', 'Favor escolher um plano de assinatura!', 'danger');
      if(!this.fields.tempo_contrato) return this.makeToast('Oops!', 'Campo tempo de contrato vazio!', 'danger');
      if(!this.fields.tempo_contrato_texto) return this.makeToast('Oops!', 'Campo tempo de contrato texto vazio!', 'danger');
      if(this.garantia) {
        if(!this.fields.mes_garantia) return this.makeToast('Oops!', 'Campo mês de garantia vazio!', 'danger');
        if(!this.fields.mes_garantia_texto) return this.makeToast('Oops!', 'Campo mês de garantia texto vazio!', 'danger');
        if(!this.fields.valor_garantia) return this.makeToast('Oops!', 'Campo valor de garantia vazio!', 'danger');
        if(!this.fields.valor_garantia_texto) return this.makeToast('Oops!', 'Campo valor de garantia texto vazio!', 'danger');
      }
      if(!this.fields.forma_pagamento) return this.makeToast('Oops!', 'Favor escolher uma forma de pagamento vazio!', 'danger');
      
      if(!this.fields.data_pagamento) return this.makeToast('Oops!', 'Favor selecionar a data do pagamento!', 'danger');
      if(!this.fields.data_pagamento_texto) return this.makeToast('Oops!', 'Campo data de pagamento por escrito esta vazio!', 'danger');
      
      return true;
    },
    validWarranty() {
      if(!this.garantia) {
        this.fields.mes_garantia = '';
        this.fields.mes_garantia_texto = '';
        this.fields.valor_garantia = '';
        this.fields.valor_garantia_texto = '';
      }
    },
    hasMarketing(){
      if(!this.fields.marketing_incluso) {
        this.garantia = false
        this.validWarranty();
      }
    }
  }
};
</script>

<style scoped>
.newPlan {
  float: right;
}
.iconCursor {
  cursor: pointer;
}
.butonCupom {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>
